// extracted by mini-css-extract-plugin
module.exports = {"tileWH":"9%","tileContainerWH":"12%","tileContainerLengthMobile":"16%","againButton":"AgainButton_againButton__nQXo1"};